import { Box, Tab, Tabs } from "@mui/material";
import { Feature } from "ol";
import { Point } from "ol/geom";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import * as React from "react";
import styled from "styled-components";
import { pointDropStyle } from "../../lib/layers/interactions/point_drop";
import { LatLongDecimal } from "../../lib/map";
import WaypointFeature from "../../lib/models/WaypointFeature";
import AirbasesTable from "../AirbasesTable";
import CoordinatesInput from "../CoordinatesInput";
import { useMap } from "../MapCanvas/MapCanvas";
import SupportAssetsTable from "../SupportAssetsTable";
import TabPanel from "../TabPanel";
import PlayerGroups from "../TaskingMap/PlayerGroups";

type Props = {
  className?: string;
};

function SearchWindow({ className }: Props) {
  const map = useMap();
  const [selected, setSelected] = React.useState(0);
  const layerRef = React.useRef(null);
  const sourceRef = React.useRef<VectorSource | null>(null);

  React.useEffect(() => {
    if (!map) {
      return;
    }
    if (!layerRef.current) {
      const source = new VectorSource();
      sourceRef.current = source;
      const layer = new VectorLayer({
        source,
        style: pointDropStyle(map),
      });
      layerRef.current = layer;
      map.addLayer(layer);
    }
  }, [map]);

  const handleCoordsSubmit = React.useCallback(
    (coordinates: LatLongDecimal) => {
      const feature = new Feature({
        geometry: new Point([coordinates.long, coordinates.lat]),
        name: "Search Result",
      });

      sourceRef.current?.addFeature(feature);
      map.getView().animate({
        center: [coordinates.long, coordinates.lat],
        duration: 500,
      });
    },
    [sourceRef.current, layerRef.current]
  );

  const handleClose = React.useCallback(() => {
    sourceRef.current?.clear();
  }, [sourceRef.current]);

  return (
    <div className={className}>
      <Tabs value={selected} onChange={(event, val) => setSelected(val)}>
        <Tab label="Player Groups" />
        <Tab label="Support Assets" />
        <Tab label="Airbases" />
        <Tab label="Coordinates" />
      </Tabs>
      <TabPanel value={selected} index={0}>
        <PlayerGroups />
      </TabPanel>
      <TabPanel value={selected} index={1}>
        <SupportAssetsTable />
      </TabPanel>
      <TabPanel value={selected} index={2}>
        <AirbasesTable />
      </TabPanel>
      <TabPanel value={selected} index={3}>
        <Box mt={2} ml={2}>
          <div>
            <h3>Search Coordinates</h3>
          </div>
          <CoordinatesInput
            initialValue={
              new WaypointFeature(
                new Feature({
                  geometry: new Point([0, 0]),
                })
              )
            }
            onSubmit={handleCoordsSubmit}
            onClose={handleClose}
            closeButtonLabel="Clear"
          />
        </Box>
      </TabPanel>
    </div>
  );
}

export default styled(SearchWindow).attrs({ className: SearchWindow.name })`
  .MuiPaper-root {
    height: 100%;
  }
`;
